<template>
  <v-container>
    <v-card class="px-5 py-3">
      <v-tabs @change="loadRow">
        <v-tab @click="deleted = false">Активные</v-tab>
        <v-tab @click="deleted = true">Не активные</v-tab>
      </v-tabs>
      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="items"
        :single-select="true"
        :items-per-page="100"
        loading-text="Идёт загрузка данных..."
        item-key="id"
        :loading="loading"
        style="cursor: pointer"
        :disable-pagination="true"
      >
        <template v-slot:[`item.index`]="{ item }">
          {{ items.indexOf(item) + 1 }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon v-if="!deleted" small class="mr-2" @click="editName(item)">
            mdi-pencil
          </v-icon>
          <v-icon
            v-if="!deleted"
            color="red"
            small
            class="mr-2"
            @click="deleteName(item.id)"
          >
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>
      <v-btn color="primary" class="ma-3" @click="create"> Добавить </v-btn>
    </v-card>
    <v-dialog v-model="dialog" max-width="600">
      <v-card>
        <v-card-title class="headline"> Название </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="foodName.name"
            label="Введите название"
            dense
          />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false"> Назад </v-btn>
          <v-btn color="primary" text @click="saveFood" :disabled="disabledBtn">
            Сохранить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="subplacedialog" max-width="600">
      <v-card>
        <v-card-title class="headline"> Редактировать название </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="foodName.name"
            label="Введите новое название"
            dense
          />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="subplacedialog = false">
            Отмена
          </v-btn>
          <v-btn
            color="primary"
            @click="newFoodName"
            text
            :disabled="disabledBtn"
          >
            Сохранить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>
import user from "../../../store/auth";
import toast from "../../../plugins/toast";
import { CompaniesApiUrls } from "@/services/accommodationRequests/companies.api.js";

export default {
  name: "Location",
  data: () => ({
    disabledBtn: false,
    deleted: false,
    foodName: {
      id: null,
      name: null
    },
    overlay: false,
    dialog: false,
    subplacedialog: false,
    selected: [],
    loading: true,
    headers: [
      { text: "№", value: "index", class: "table-title" },
      {
        text: "Название",
        value: "name",
        sortable: false,
        class: "table-title"
      },
      {
        text: "Редактировать",
        value: "actions",
        sortable: false,
        class: "table-title"
      }
    ],
    items: [],
    firstWatcherTrigger: false
  }),
  created() {
    this.loadRow();
  },
  methods: {
    async deleteName(id) {
      try {
        await CompaniesApiUrls.deleteType(id);
        toast.success("Удалено!");
        this.loadRow();
      } catch (e) {
        console.log(e);
      }
    },
    async loadRow() {
      this.loading = true;
      let params = {
        deleted: this.deleted
      };
      this.items = await CompaniesApiUrls.getTypes(params);
      this.loading = false;
    },
    editName(item) {
      this.foodName = item;
      this.subplacedialog = true;
    },
    async newFoodName() {
      this.disabledBtn = true;
      try {
        await CompaniesApiUrls.setType(
          {
            name: this.foodName.name
          },
          this.foodName.id
        );
      } finally {
        this.disabledBtn = false;
      }
      this.subplacedialog = false;
      this.loadRow();
    },
    async saveFood() {
      this.disabledBtn = true;
      await CompaniesApiUrls.createType({ name: this.foodName.name });
      this.disabledBtn = false;
      this.dialog = false;
      this.loadRow();
    },
    create() {
      this.dialog = true;
    }
  }
};
</script>

<style scoped>
.title {
  font-size: 18px !important;
  font-weight: 500 !important;
  color: orange !important;
  padding-bottom: 0 !important;
  padding-top: 0 !important;
}
</style>
